import { jsx as _jsx } from "react/jsx-runtime";
import ProductDetails from './presentation/components/productDetails';
import dependencyInjectionInfrastructure from "./infrastructure/dependencyInjectorInfrastructure";
import dependencyInjectionApplication from './application/dependency_injector_application';
import './infrastructure/i18n/i18n';
import { useLogrocket } from "./infrastructure/utils/logrocket";
function AppProductDetails() {
    dependencyInjectionInfrastructure();
    dependencyInjectionApplication();
    useLogrocket();
    return (_jsx("div", { className: "App", style: { position: 'relative' }, children: _jsx(ProductDetails, {}) }));
}
export default AppProductDetails;
